module.exports = __webpack_public_path__ + "static/media/to-top-grey-arrow.daf00274.svg";